import useGeoLocation from "react-ipgeolocation";

const locations = ['London, UK', 'Hamburg, Germany', 'New York, US'];

const isBrowser = typeof window !== "undefined"

const GeoDetect = () => {
    if (isBrowser) {
        if (window && window.location && window.location.host) { 
          if (window.location.host.indexOf("thedataschool.de") > -1) {
            console.log('[GeoDetect.js] Location detected as: Germany');
            return locations[1];
          } else if (window.location.host.indexOf("thedataschool.com") > -1) {
            console.log('[GeoDetect.js] Location detected as: USA');
            return locations[2];
          }
        }
    }
    console.log('[GeoDetect.js] Location detected as: UK/Other');
    return locations[0];
}

export { locations, GeoDetect, useGeoLocation }